export default __webpack_public_path__ + "static/media/map.9b6f6a64.png";